module.exports = __webpack_public_path__ + "media/images/flags/16/India-afa52bea4e230695ff706ba149120359.png";